import React from 'react'
import { Link } from 'react-router-dom'
import { translate } from 'react-i18next'
import { arrayOf, shape, string, func, bool } from 'prop-types'
import config from '../../config'

const SubHeroComponent = ({ t, breadcrumb, fixed }) => (
  <div className={`subhero ${fixed ? 'fixed' : ''}`}>
    <div className='layout__container'>
      <span>
        <a href={config.homepage_url}><span>{t('common:home')}</span></a>
        { breadcrumb.length > 0 ? ' > ' : '' }
      </span>
      {breadcrumb.map((link, i) => {
        if (link.path) {
          return (<span key={i}><Link onClick={link.onClick} to={link.path}>{link.name}</Link>{ breadcrumb.length - 1 === i ? '' : (<span> &gt; </span>) }</span>)
        }
        return <span key={i}>{link.name} { breadcrumb.length - 1 === i ? '' : '>' } </span>
      })}
    </div>
  </div>
)

SubHeroComponent.propTypes = {
  t: func,
  fixed: bool,
  breadcrumb: arrayOf(shape({
    name: string,
    path: string,
    onClick: func
  }))
}

export const SubHero = translate()(SubHeroComponent)



// WEBPACK FOOTER //
// ./src/components/header/SubHero.js